module.exports = __webpack_public_path__ + "static/media/medicine.7d6e208a.svg";